<template>
  <div>
    <div class="style-home-page container justify-content-center p-0">
      <branch-information />

      <pull-to-refresh :refresh-function="handleRefresh">
        <!-- CWA banners -->
        <slides :banners="init.banners" />

        <!-- Promotion service section -->
        <promotion-services v-if="init.promotionPublished" />
        <service-item
          v-if="init.promotionPublished && promotionServicesLimited"
          :items="promotionServicesLimited"
          :hidePrice="init.hideServicePrice"
          :handleItem="viewItemDetail"
          :handleItemSelection="goToMakeAppointmentForPromotionService"
          :handleSeeAllButton="goToPromotion"
        />
        <promotion-message />

        <!-- Popular service section -->
        <list-header title="Popular Services" />
        <service-item
          v-if="popularServices"
          :items="popularServices"
          :hidePrice="init.hideServicePrice"
          :handleItem="viewItemDetail"
          :handleItemSelection="goToMakeAppointment"
          :handleSeeAllButton="goToServices"
        />
      </pull-to-refresh>
    </div>

    <toast-safari-installation v-if="showPWAInstallationToast" />
  </div>
</template>

<script>
import {
  defineAsyncComponent,
  markRaw
} from "vue";
import Slides from "@/components/Slides.vue";
import BranchInformation from "./components/BranchInformation.vue";
import PromotionMessage from "./components/PromotionMessage.vue";
import { mapGetters, mapActions } from "vuex";
import ToastSafariInstallation from "@/components/ToastSafariInstallation.vue";
import PullToRefresh from "@/components/PullToRefresh.vue";
import PromotionServices from "./components/PromotionServices.vue";
import ServiceItem from "./components/ServiceItem.vue";
import ListHeader from "@/components/ListHeader.vue";
import { useToast } from "vue-toastification";
import { openModal, closeModal } from "@/store/modal";

export default {
  name: "Home",
  components: {
    Slides,
    BranchInformation,
    PromotionMessage,
    ToastSafariInstallation,
    PullToRefresh,
    PromotionServices,
    ListHeader,
    ServiceItem,
  },
  data() {
    return {
      selectedService: null,
    };
  },
  computed: {
    ...mapGetters([
      "init",
      "showPWAInstallationToast",
      "popularServices",
      "promotionServicesLimited",
    ]),
  },
  methods: {
    async handleRefresh() {
      // Fetch data parallely
      await Promise.all([
        (async () => await this.getInit())(),
        (async () => await this.getPopularServices())(),
        (async () => await this.getPromotionServices())(),
      ]);
    },
    goToServices() {
      this.$router.push("/services");
    },
    goToPromotion() {
      this.$router.push("/promotion");
    },
    goToMakeAppointmentForPromotionService(service) {
      if (!service.futurePromotion) {
        this.goToMakeAppointment(service);
      } else {
        useToast().warning("Promotion not started.");
      }
    },
    goToMakeAppointment(service) {
      const serviceDetails = {
        description: service.description,
        id: service.id,
        imageURL: service.image,
        name: service.name,
        type: service.type,
        processingTime: service.service.processingTime,
        formatProcessingTime: service.service.formatProcessingTime,
        price: service.price,
        promotion: service.promotion,
        promotionId: service.service.promotionId,
        promotionPrice: service.service.promotionPrice,
        promotionStartDate: service.service.startDate,
        promotionEndDate: service.service.endDate,
        originalPrice: service.originalPrice,
        salePrice: service.salePrice,
        prepaidItemId: 0,
        sectionName: service.productSection?.name,
        categoryName: service.productCategory?.name,
      };
      sessionStorage.setItem("serviceDetails", JSON.stringify(serviceDetails));
      this.$router.push("/make-appointment");
    },
    viewItemDetail(service) {
      openModal(
        {
          id: "expandableListItemDetailModal",
        },
        markRaw(defineAsyncComponent(() => import("@/components/ExpandableListItemDetail.vue"))),
        {
          image: service.image,
          processingTime: service.service.formatProcessingTime,
          name: service.name,
          description: service.description,
          originalPrice: service.futurePromotion ? service.futureOriginalPrice : service.originalPrice,
          salePrice: service.futurePromotion ? service.futureSalePrice : service.salePrice,
          section: service.productSection?.name,
          category: service.productCategory?.name,
          promotion: service.promotion,
          futurePromotion: service.futurePromotion,
          hidePrice: this.init.hideServicePrice,
        },
        {},
        [
          {
            text: 'Book',
            class: 'scss-blue-button',
            clickFn: () => {
              if (!service.futurePromotion) {
                this.goToMakeAppointment(service);
                closeModal();
              } else {
                useToast().warning("Promotion not started.");
              }
            }
          },
          {
            text: 'Close',
            clickFn: () => {
              closeModal();
            }
          }
        ]
      );
    },
    ...mapActions(["getInit", "getPopularServices", "getPromotionServices"]),
  },
};
</script>
<style lang="scss" scoped>
.style-home-page {
  margin-bottom: 70px;
}

.style-button-container {
  border: 1px solid $border-light-grey;
  position: fixed;
  bottom: 53px;
  background-color: white;
  max-width: 510px;
}
</style>
